(() => {
  if (window.__pawcareProductConversionBound) return;
  window.__pawcareProductConversionBound = true;

  const normalise = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const push = (event, payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event, ...payload });
  };

  document.querySelectorAll('[data-pc-product-analytics-data]').forEach((node) => {
    let product;
    try {
      product = JSON.parse(node.textContent);
    } catch (_error) {
      return;
    }

    if (!product?.id || node.dataset.pcAnalyticsBound === 'true') return;
    node.dataset.pcAnalyticsBound = 'true';

    const section = node.closest('.shopify-section') || document;
    const currentVariantId = () => section.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value;
    const variantFor = (variantId) =>
      product.variants.find((variant) => String(variant.id) === String(variantId || currentVariantId()));
    const item = (variantId, quantity = 1) => {
      const variant = variantFor(variantId);
      return {
        item_id: String(variant?.sku || variant?.id || product.id),
        item_name: product.title,
        item_variant: variant?.public_title || variant?.title || undefined,
        price: Number(variant?.price || 0) / 100,
        quantity
      };
    };
    const ecommerce = (variantId, quantity = 1) => {
      const currentItem = item(variantId, quantity);
      return {
        currency: product.currency,
        value: currentItem.price * currentItem.quantity,
        items: [currentItem]
      };
    };

    push('view_item', { ecommerce: ecommerce(), pc_product_id: String(product.id), pc_product_url: product.url });

    document.addEventListener('variant:update', (event) => {
      const updatedProductId = String(event.detail?.data?.productId || '');
      if (updatedProductId !== String(product.id)) return;

      const updatedVariantId = event.detail?.resource?.id;
      if (!updatedVariantId || !variantFor(updatedVariantId)) return;
      const currentItem = item(updatedVariantId);
      push('pc_product_variant_select', {
        pc_product_id: String(product.id),
        pc_variant_id: String(updatedVariantId || variantFor()?.id || ''),
        pc_variant_title: currentItem.item_variant || ''
      });
    });

    document.addEventListener('cart:update', (event) => {
      const eventData = event.detail?.data || {};
      const isConfirmedProductFormAdd =
        eventData.source === 'product-form-component' &&
        eventData.didError !== true &&
        String(eventData.productId || '') === String(product.id);

      if (!isConfirmedProductFormAdd) return;

      const quantity = Math.max(1, Number(eventData.itemCount) || 1);
      const confirmedVariantId = event.detail?.sourceId;
      if (!confirmedVariantId || !variantFor(confirmedVariantId)) return;

      push('add_to_cart', {
        ecommerce: ecommerce(confirmedVariantId, quantity),
        pc_product_id: String(product.id),
        pc_product_url: product.url,
        pc_variant_id: String(confirmedVariantId || ''),
        pc_add_source: 'confirmed_cart_update'
      });
    });

    section.addEventListener('toggle', (event) => {
      const fact = event.target;
      if (!fact.matches?.('[data-pc-product-fact]') || !fact.open) return;
      push('pc_product_fact_open', {
        pc_product_id: String(product.id),
        pc_product_fact: fact.dataset.pcProductFact || ''
      });
    }, true);

    section.addEventListener('click', (event) => {
      const link = event.target.closest?.('[data-pc-track="guide-link"]');
      if (!link) return;
      push('pc_product_guide_click', {
        pc_product_id: String(product.id),
        pc_guide_label: normalise(link.textContent),
        pc_guide_url: link.href
      });
    });
  });
})();
